
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      videos: [],
    };
  },
  computed: {
  },
  mounted () {
    this.getVideos();
  },
  methods: {
    async getVideos () {
      const params = {
        fields: `id,title,slug,image,date`,
        posts: {
          posts_per_page: 3,
          post_type: `video`,
          post__not_in: [this.post.id],
          post_status: `publish`,
        },
        options: {
          image_size: `large`,
        },
      };
      const request = await this.$getPosts(`/posts`, params);
      if (request !== null) {
        this.videos = request;
      }
    },
  },
};
